import { Button, ButtonProps } from 'react-bootstrap';
import { ReactNode } from 'react';

export type IconButtonProps = ButtonProps & {
  children?: ReactNode;
};

export const IconButton = ({ children, ...props }: IconButtonProps) => (
  <Button
    {...props}
    style={{
      padding:
        props.size === 'sm'
          ? '0.5rem'
          : props.size === 'lg'
            ? '1rem'
            : '0.75rem',
      borderRadius: '50%',
      lineHeight: '1ch',
      ...props.style,
    }}
  >
    {children}
  </Button>
);
